module.exports = __webpack_public_path__ + "static/media/visuel06.26e67415.jpg";